export const appId = 'org.openedx.frontend.app.learnerDashboard';
export const dashboardRole = 'org.openedx.frontend.role.dashboard';
export const coursesRole = 'org.openedx.frontend.role.courses';
